export default __webpack_public_path__ + "static/media/close-production.70db3a25.svg";